import {
  AntimalwareSettingsExclusionsModuleType,
  AntimalwareSettingsExclusionsTaskType,
} from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { Feature } from '@nirvana/shared/constants';

export function getAvailableModuleOptionsByType(
  type: AntimalwareSettingsExclusionsTaskType,
  applyFeatureRestrictions: boolean = true
): AntimalwareSettingsExclusionsModuleType[] {
  const isCompanionStandalone = Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_COMPANION_STANDALONE]);
  const hasRestrictions = applyFeatureRestrictions && isCompanionStandalone;

  switch (type) {
    case AntimalwareSettingsExclusionsTaskType.FILE:
      return hasRestrictions
        ? []
        : [AntimalwareSettingsExclusionsModuleType.ON_DEMAND, AntimalwareSettingsExclusionsModuleType.ON_ACCESS];
    case AntimalwareSettingsExclusionsTaskType.FOLDER:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [
            AntimalwareSettingsExclusionsModuleType.ON_DEMAND,
            AntimalwareSettingsExclusionsModuleType.ON_ACCESS,
            AntimalwareSettingsExclusionsModuleType.AVC_IDS,
            AntimalwareSettingsExclusionsModuleType.RANSOMWARE_REMEDIATION,
          ];
    case AntimalwareSettingsExclusionsTaskType.EXTENSION:
      return hasRestrictions
        ? []
        : [AntimalwareSettingsExclusionsModuleType.ON_DEMAND, AntimalwareSettingsExclusionsModuleType.ON_ACCESS];
    case AntimalwareSettingsExclusionsTaskType.PROCESS:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [
            AntimalwareSettingsExclusionsModuleType.ON_ACCESS,
            AntimalwareSettingsExclusionsModuleType.AVC_IDS,
            AntimalwareSettingsExclusionsModuleType.RANSOMWARE_REMEDIATION,
          ];
    case AntimalwareSettingsExclusionsTaskType.FILE_HASH:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [
            AntimalwareSettingsExclusionsModuleType.ON_DEMAND,
            AntimalwareSettingsExclusionsModuleType.ON_ACCESS,
            AntimalwareSettingsExclusionsModuleType.AVC_IDS,
          ];
    case AntimalwareSettingsExclusionsTaskType.CERTIFICATE_HASH:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [
            AntimalwareSettingsExclusionsModuleType.ON_DEMAND,
            AntimalwareSettingsExclusionsModuleType.ON_ACCESS,
            AntimalwareSettingsExclusionsModuleType.AVC_IDS,
          ];
    case AntimalwareSettingsExclusionsTaskType.THREAT_NAME:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [
            AntimalwareSettingsExclusionsModuleType.ON_DEMAND,
            AntimalwareSettingsExclusionsModuleType.ON_ACCESS,
            AntimalwareSettingsExclusionsModuleType.AVC_IDS,
          ];
    case AntimalwareSettingsExclusionsTaskType.CMD_PARAMS:
      return hasRestrictions
        ? [AntimalwareSettingsExclusionsModuleType.AVC_IDS]
        : [AntimalwareSettingsExclusionsModuleType.ON_ACCESS, AntimalwareSettingsExclusionsModuleType.AVC_IDS];
    case AntimalwareSettingsExclusionsTaskType.IP_MASK:
      return hasRestrictions ? [] : [AntimalwareSettingsExclusionsModuleType.RANSOMWARE_REMEDIATION];
    default:
      return [];
  }
}

export function getPathPlaceholderByType(type: AntimalwareSettingsExclusionsTaskType): string {
  switch (type) {
    case AntimalwareSettingsExclusionsTaskType.FILE:
      return translateFn('Enter the file path');
    case AntimalwareSettingsExclusionsTaskType.FOLDER:
      return translateFn('Enter the folder path');
    case AntimalwareSettingsExclusionsTaskType.EXTENSION:
      return translateFn('Specify extensions (example: jpg;txt;avi;png)');
    case AntimalwareSettingsExclusionsTaskType.PROCESS:
      return translateFn('Enter the process path');
    case AntimalwareSettingsExclusionsTaskType.FILE_HASH:
      return translateFn('Enter the file hash value (SHA-256)');
    case AntimalwareSettingsExclusionsTaskType.CERTIFICATE_HASH:
      return translateFn('Enter the certificate thumbprint');
    case AntimalwareSettingsExclusionsTaskType.THREAT_NAME:
      return translateFn('Enter the detection name');
    case AntimalwareSettingsExclusionsTaskType.CMD_PARAMS:
      return translateFn('Enter the command line');
    case AntimalwareSettingsExclusionsTaskType.IP_MASK:
      return translateFn('Enter the IP address');
    default:
      return '';
  }
}
